<form class="position-relative" #dropdown="ngbDropdown" ngbDropdown>
  <input
    class="form-control"
    #input
    [placeholder]="'search.search' | translate"
    (focus)="onChange()"
    (input)="onChange()"
    (keydown)="onKeyDown($event)"
    autocomplete="off"
    name="search"
    type="text"
  />

  <ul class="search-input__suggestions" ngbDropdownMenu>
    <!-- Enterprise -->
    @if (showEnterprise) {
      <li
        class="dropdown-item g-cursor-pointer d-inline-flex align-items-center justify-content-between"
        [ngClass]="{ 'dropdown-item--highlight': 0 === activeIndex }"
        (click)="submit('enterprise')"
        role="button"
      >
        <div class="flex-grow-1 me-2">
          {{ query }}
        </div>
        <div class="badge text-bg-dark mt-0">
          <span>{{ 'search.enterprise' | translate }}</span>
          <span class="ms-1">↵</span>
        </div>
      </li>
    }

    <!-- Service Provider -->
    @if (showServiceProvider) {
      <li
        class="dropdown-item g-cursor-pointer d-flex align-items-center"
        [ngClass]="{ 'dropdown-item--highlight': 1 === activeIndex }"
        (click)="submit('reseller')"
        role="button"
      >
        <div class="flex-grow-1 me-2">
          {{ query }}
        </div>
        <div class="badge text-bg-dark mt-0">
          <span>{{ 'search.serviceProvider' | translate }}</span>
          <span class="ms-1">↵</span>
        </div>
      </li>
    }
  </ul>
</form>
